export const ALLROUTES = {
  index: '首页',
  live: '直播列表',
  news: '要闻列表',
  column: '栏目首页',
  market: '行情首页',
  'stock-id': '股票首页',
  'p-id': '文章详情页',
  member: '会员首页',
  subject: '主题首页',
  'index-tag-type': '首页-标签',
};
